/**
  * 用户 接口的统一出口
  */
 import axios from '../http' // 导入http中创建的axios实例
 import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
 
 const index = {
    // 列表
    list (params) {
        return axios.get('/home/custommade/list', { params: params })
    },
	// 定制详情
	detail (params) {
		return axios.get('/home/custommade/detail', { params: params })
	},
	// 分类列表
	catelist (params) {
		return axios.get('/home/custommade/catelist', { params: params })
	},
	// 生成订单
	createOrder (params) {
		return axios.post('/home/custommade/order/create', qs.stringify(params))
	},
	// 支付
	topay (params) {
		return axios.post('/home/made/topay', qs.stringify(params))
	},
	// 订单列表
    orderList (params) {
		return axios.get('/home/custommade/order/list', { params: params })
	},
	// 订单详情
    orderDetail (params) {
		return axios.get('/home/custommade/order/detail', { params: params })
	},
	// 物流信息
    logsticsList (params) {
		return axios.get('/home/custommade/logstics/list', { params: params })
	},
	// 确认收货
	confirmorder (params) {
		return axios.post('/home/custommade/confirmorder', qs.stringify(params))
	},
	// 邮费自提点
	fare (params) {
		return axios.get('/home/custommade/fare', { params: params })
	},
	// 匠人发布定制
	tradcreate (params) {
		return axios.post('/home/custommade/tradcreate', qs.stringify(params))
	},
	// 专属定制  发布定制
	specialCreate (params) {
		return axios.post('/home/custommade/special/create', qs.stringify(params))
	},
	// 专属定制  定制详情
	specialDetail (params) {
		return axios.get('/home/custommade/zs_detail', { params: params })
	},
	// 专属定制  定制匠人
	tralist (params) {
		return axios.get('/home/custommade/tralist', { params: params })
	},
	// 定制社区 用户发布定制
	usercreate (params) {
		return axios.post('/home/custommade/usercreate', qs.stringify(params))
	},
	// 定制社区列表
	comunitylist (params) {
		return axios.get('/home/custommade/comunitylist', { params: params })
	},
	// 定制社区 定制详情
	comunitydetail (params) {
		return axios.get('/home/custommade/comunitydetail', { params: params })
	},
	// 定制社区 修改定制
	useredit (params) {
		return axios.post('/home/custommade/useredit', qs.stringify(params))
	},
	// 定制社区 商家报名定制
	tradsignup (params) {
		return axios.post('/home/custommade/tradsignup', qs.stringify(params))
	},
	// 定制社区 确认合作
	agreetrad (params) {
		return axios.post('/home/custommade/agreetrad', qs.stringify(params))
	},
	// 定制社区 用户取消定制
	usercancel (params) {
		return axios.post('/home/custommade/cancel', qs.stringify(params))
	},
	// 我的定制，审核中/招标中
	mylist (params) {
		return axios.get('/home/custommade/mylist', { params: params })
	},
	// 匠人定制作品
	trawork (params) {
		return axios.get('/home/custommade/trawork', { params: params })
	},
	// 定制配置信息
	madeInfo (params) {
		return axios.get('/home/madeinfo/detail', { params: params })
	},
	// 定制单详情信息
	madeDetailInfo (params) {
		return axios.get('/home/madeinfo/info', { params: params })
	},
	// 提交定制配置信息
	submitMadeInfo(params){
		return axios.post('/home/madeinfo/submit', qs.stringify(params))
	},
	traCorList(params) {
		return axios.get('/home/custommade/tradelist', { params: params })
	},
	// 商家定制列表
	tradeclist(params){
		return axios.post('/home/custommade/tradeclist', qs.stringify(params))
	},
	// 商家定制,编辑价格
	tradeEditprice(params){
		return axios.post('/home/custommade/editprice', qs.stringify(params))
	},
	// 收藏定制品
	attention(params){
		return axios.post('/home/custommade/attention', qs.stringify(params))
	},
	// 点赞定制品
	like(params){
		return axios.post('/home/custommade/click', qs.stringify(params))
	},
	// 评论
	comment(params){
		return axios.post('/home/custommade/comment', qs.stringify(params))
	},
	// 订单评论
	orderComment(params){
		return axios.get('/home/custommade/ordercomment', { params: params })
	},
	// 定制单快照
	orderPhoto(params){
		return axios.get('/home/custommade/order/photo', { params: params })
	},
	// 用户定制价格列表
	usermadepriceList(params){
		return axios.get('/home/usermadeprice/list', { params: params })
	},
	// 添加用户定制价格
	usermadepriceCreate(params){
		return axios.post('/home/usermadeprice/create', qs.stringify(params))
	},
	// 修改用户定制价格
	usermadepriceEdit(params){
		return axios.post('/home/usermadeprice/edit', qs.stringify(params))
	},
	// 用户定制价格详情
	usermadepriceDetail(params){
		return axios.get('/home/usermadeprice/detail', { params: params })
	},
	// 用户定制价格删除
	usermadepriceRemove(params){
		return axios.post('/home/usermadeprice/remove', qs.stringify(params))
	}
 }
 
 // 导出接口
 export default index